import {courseService} from '@jobseeker/common-core/services';
import {WhiteChevronRight} from '@jobseeker/lotus/assets/icons';
import {Card} from '@jobseeker/lotus/components';
import Carousel from '@jobseeker/lotus/components/Carousel';
import {Box, IconButton, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';
import {Course} from './types';
import {openCourseDetailPage} from './utils';

const FeaturedCourses = () => {
  const [featuredCourses, setFeaturedCourses] = useState<Course[]>([]);

  useEffect(() => {
    courseService
      .getFeaturedCourses()
      .then((data: {CourseList: Course[]}) =>
        setFeaturedCourses(data.CourseList)
      );
  }, []);

  const featuredCoursesCarouselItems = featuredCourses.map(
    ({logo, title, institute, id}, idx) => (
      <Card key={idx} heading="" variant="" sx={{p: 0}}>
        <Box
          display="flex"
          bgcolor="white"
          maxWidth={444}
          height={140}
          py={2}
          px={2}
          onClick={() =>
            openCourseDetailPage(title, id, {
              refinv: 'lhome',
              reforg: 'featured',
            })
          }
          sx={{
            cursor: 'pointer',
          }}
          gap={3}
          border="1px solid rgb(204, 204, 204)"
          borderRadius="2px"
        >
          <Image
            src={logo}
            alt="XLRI Jamshedpur | Postgraduate Certificate in Senior Leadership (Batch 6)"
            width={88}
            height={88}
            style={{
              objectFit: 'contain',
            }}
          />
          <Box width={309}>
            <Typography fontSize={14} fontWeight={400}>
              {title}
            </Typography>
            <Typography fontWeight={600} fontSize={14} mt={2}>
              {institute}
            </Typography>
          </Box>
        </Box>
      </Card>
    )
  );

  return (
    <Box
      className="featured-courses"
      bgcolor="rgb(245, 244, 238)"
      p={1.25}
      height="fit-content"
      display="flex"
      justifyContent="space-between"
    >
      <Typography
        className="featured-course-heading"
        width={25}
        height={140}
        bgcolor="black"
        color="white"
        textAlign="center"
        sx={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transform: 'rotate(180deg)',
        }}
      >
        FEATURED
      </Typography>
      <Box maxWidth={1370} overflow="hidden" px={2}>
        <Carousel
          next=".next-featured-course"
          previous=".previous-featured-course"
          carouselItems={featuredCoursesCarouselItems}
          breakpointOverrides={{
            1440: {slidesPerView: 3, spaceBetween: 10},
            1024: {slidesPerView: 3, spaceBetween: 12},
            375: {slidesPerView: 1, spaceBetween: 15},
            320: {slidesPerView: 1, spaceBetween: 9},
          }}
        />
      </Box>
      <Box
        width={25}
        height={140}
        bgcolor="black"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        py={2}
      >
        <IconButton className="next-featured-course">
          <Image src={WhiteChevronRight} width={16} height={16} alt="right" />
        </IconButton>
        <IconButton className="previous-featured-course">
          <Image
            src={WhiteChevronRight}
            width={16}
            height={16}
            alt="left"
            style={{transform: 'rotate(180deg)'}}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FeaturedCourses;
